export const MOCKED_COMPANIES_IDS = [
  "56cb91bdc3464f14678934ca",
  "5f0dbdacdffd820004608fd2",
];
